import React from "react";

import TermsContent from "../../../components/Common/Terms";

const Terms = ({ onClickClose }) => {
  const handleClickClose = () => {
    if (onClickClose) {
      onClickClose("termsSection");
    } else {
      window.location.href = "/";
    }
  };
  return (
    <div>
      {/* Header */}
      <div className="head-general with-back visible-xs">
        <a href="javascript: void(0)" />
        <h4>Terms and Conditions</h4>
        <a
          href="javascript: void(0)"
          onClick={handleClickClose}
          className="close"
        >
          <icon className="icon icon-close" />
        </a>
      </div>
      {/* Header */}
      <TermsContent className="mt-0" />
    </div>
  );
};

export default Terms;
